"use client";
import Link from "next/link";
import { useEffect, useState } from "react";
import Nimage from "./image";

export default function NewsSocialShare({ data }: any) {
    const [currentUrl, setCurrentUrl] = useState("");
    const [currentTitle, setCurrentTitle] = useState("");
    const [showToastMsg, setShowToastMsg] = useState(false);

    useEffect(() => {
        setCurrentUrl(encodeURIComponent(window.location.href));
        const titleElement = document.querySelector(".main_blog_title");
        // console.log("currentUrl",currentUrl);
        
        if (titleElement) {
            setCurrentTitle(
                encodeURIComponent(titleElement.textContent?.trim() || "")
            );
        }
    }, []);


    const replacePlaceholders = (pattern: string) =>
        pattern
            .replace("{url}", currentUrl)
            .replace("{title}", currentTitle);

    const copyToClipboard = (text: string) => {
        navigator.clipboard.writeText(text);
        setShowToastMsg(true);
        setTimeout(() => setShowToastMsg(false), 2000);
    };

    return (
        <div className="social-icons">
            {data?.socialmedialist1766298478.map((item: any) => {
                const linkPattern = item?.sharelink1766298654?.trim();

                const isOnlyUrl = linkPattern === "{url}";

                return isOnlyUrl ? (
                    <div className="copy_link_area" key={item.uid}>
                        <button className="copy_link cursor-pointer" type="button"
                            key={item.uid}
                            onClick={() => copyToClipboard(currentUrl)}
                            title="Copy link"
                        >
                            {item?.icon1766298516?.map((immg: any, index: number) => (
                                <Nimage
                                    key={item.uid + immg.url + index}
                                    immg={immg}
                                    data={data}
                                    height="20"
                                />
                            ))}
                        </button>
                        {showToastMsg &&
                            (
                                <div className="text_copied animate-fade-in-out">
                                    Link Copied!
                                </div>
                            )
                        }
                    </div>
                ) : (
                    <Link
                        key={item.uid}
                        href={replacePlaceholders(linkPattern)}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {item?.icon1766298516?.map((immg: any, index: number) => (
                            <Nimage
                                key={item.uid + immg.url + index}
                                immg={immg}
                                data={data}
                                height="20"
                            />
                        ))}
                    </Link>
                );
            })}
        </div>
    );
}
